export default __webpack_public_path__ + "static/media/linkedin.89afb80e.svg";